import { TrashBin } from "@gravity-ui/icons";
import {
  Alert,
  Button,
  Card,
  Flex,
  Icon,
  Text,
  Tooltip,
} from "@gravity-ui/uikit";
import { useAction } from "@reatom/npm-react";
import { ExportTaskDto } from "definitions/exporter";
import { useCallback } from "react";
import { Link } from "react-router-dom";
import { RoutesPaths } from "src/routes/RoutesPaths";
import { formatDate } from "src/util";
import { ShowConfirmDialog } from "src/widgets/Alert/Alert";

import { deleteExportTaskRequest } from "../../store/fetchers";
import css from "./ExportTaskCard.module.scss";

interface ExportTaskCardProps {
  task: ExportTaskDto;
}

export const ExportTaskCard = ({ task }: ExportTaskCardProps) => {
  const deleteExportTask = useAction(deleteExportTaskRequest);

  const handleDeleteExportTask = useCallback(
    (
      e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement, MouseEvent>,
    ) => {
      e.stopPropagation();
      e.preventDefault();
      ShowConfirmDialog(
        <Alert
          theme="danger"
          title="Все задачи этой выгрузки удалятся!"
          message="Вы действительно хотите удалить выгрузку?"
        />,
        "Подтвердите действие",
      ).then((result) => {
        if (result) {
          deleteExportTask({ id: task.id });
        }
      });
    },
    [deleteExportTask, task.id],
  );

  return (
    <Link
      to={RoutesPaths.LK.EXPORT_TASK(task.id)}
      style={{ textDecoration: "none" }}
    >
      <Card
        className={css.exportTaskCard}
        view="filled"
        theme="normal"
        size="m"
      >
        <Flex direction="column" maxWidth={"75%"}>
          <Text
            variant="subheader-2"
            color="warning-heavy"
            className={css.exportTaskCardTitle}
          >
            {task.filename}
          </Text>
          <Text variant="caption-2" color="secondary">
            {formatDate(new Date(task.createdAt))}
          </Text>
        </Flex>

        <Flex direction="row" wrap="wrap" gap="0.5" justifyContent="end">
          <Tooltip content="Удалить выгрузку" placement="top" openDelay={200}>
            <Button view="flat" onClick={handleDeleteExportTask}>
              <Icon data={TrashBin} size={16} />
            </Button>
          </Tooltip>
        </Flex>
      </Card>
    </Link>
  );
};
